import {
  AutocompleteArrayInput, ReferenceArrayInput,
  Button, CreateButton, DeleteButton, EditButton, SaveButton, SimpleForm, TextField, Toolbar, TopToolbar,
  useTranslate,
} from 'react-admin';
import { Datagrid } from '@react-admin/ra-rbac';
import { ListLive } from '@react-admin/ra-realtime';
import {
  required, useRecordContext,
} from 'ra-core';
import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import { LIST_DEBOUNCE } from '../../../config';
import SearchFields from '../components/fields/Filters';
import { TimeGranularityField } from '../../../components/fields/TimeGranularityField';
import { EditWithSuccess } from '../../../components/baseForms/EditWithSuccess';
import { GrayTextInputWithUpperLabel } from '../components/inputs/GrayTextInputWithUpperLabel';
import { AssetsInDialogButton } from '../../../components/buttons/assetsInDialogButton';
import { GrayTimeGranularityInputWithUpperLabel } from '../components/inputs/GrayTimeGranularityInputWithUpperLabel';

export const InventoryCategoriesList = () => {

  const translate = useTranslate();

  return (
    <>
      <h3>{translate('resources.security_inventory_categories.title')}</h3>
      <p>{translate('resources.security_inventory_categories.text.sub_title')}</p>
      <ListLive filters={SearchFields} debounce={LIST_DEBOUNCE}
        actions={<TopToolbar><CreateButton label="general.text.add_from_presets" /></TopToolbar>}>
        <Datagrid rowClick={false} bulkActionButtons={false}>
          <TextField source="name" label="general.fields.name"/>
          <TimeGranularityField source="expiryInterval" label="resources.security_inventory_categories.fields.inspection_period"/>
          <AssetsInDialogButton label="resources.security_inventory_categories.fields.people_to_notify" resource="security-inventory-categories" />
          <EditButton resource="security-inventory-categories"/>
          <DeleteButton resource="security-inventory-categories"/>
        </Datagrid>
      </ListLive>
    </>
  );

};

const inventoryCategoryEditTransformer = (data: any) => {

  return {
    ...data,
    peopleToNotify: (data.peopleToNotify ?? []).map((personId: string) => ({
      _id: personId,
      _ref: 'Asset',
    })),
  };

};

const InventoryCategoryEditToolbar = () => {

  const navigate = useNavigate();

  return (
    <Toolbar sx={{ justifyContent: 'space-between', maxWidth: '1000px' }}>
      <Button label='ra.action.back' onClick={() => navigate(-1)} size="medium" sx={{ marginRight: '10px' }} variant="text"/>
      <SaveButton />
    </Toolbar>
  );

};

const InventoryCategoryEditForm = () => {

  const translate = useTranslate();
  const record = useRecordContext();

  return (
    <>
      <h4 style={{ marginBottom: '10px' }}>"{record?.name}" {translate('general.text.settings')}</h4>
      <Typography variant="body1">{translate('resources.security_inventory_categories.text.settings_sub_title')}</Typography>
      <hr/>
      <GrayTextInputWithUpperLabel source="name" validate={required()} label="general.fields.name"/>
      <ReferenceArrayInput source="peopleToNotify" reference="app-users" label="resources.security_inventory_categories.fields.people_to_notify">
        <AutocompleteArrayInput label="resources.security_inventory_categories.fields.people_to_notify"/>
      </ReferenceArrayInput>
      <GrayTimeGranularityInputWithUpperLabel source="expiryInterval" label="resources.security_inventory_categories.fields.inspection_period"/>
    </>
  );

};

export const InventoryCategoryEdit = () => {

  return (
    <>
      <EditWithSuccess transform={inventoryCategoryEditTransformer} title="resources.security_inventory_categories.title" actions={false}>
        <SimpleForm sx={{ maxWidth: '1000px' }} toolbar={<InventoryCategoryEditToolbar/>}>
          <InventoryCategoryEditForm/>
        </SimpleForm>
      </EditWithSuccess>
    </>
  );

};
